import { Link as RouterLink } from "react-router"

import { APP_COMPANY_NAME } from "@/utils/constants"

import { Link } from "@mui/material"
import { useTheme } from "@mui/material/styles"

import { NzeroLogo } from "../logo/nzeroLogo"

import styles from "./unauthenticatedAppHeader.module.scss"

export const UnauthenticatedAppHeader = () => {
  const theme = useTheme()

  return (
    <header
      className={styles.root}
      style={{
        backgroundColor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
      }}
    >
      <Link
        aria-label={APP_COMPANY_NAME}
        component={RouterLink}
        sx={{
          color: theme.palette.text.primary,
          display: "inline-flex",
        }}
        to="/"
        underline="none"
      >
        <NzeroLogo width={112} />
      </Link>
    </header>
  )
}
